import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzPt1Bg } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PT1_BG: Record<
  Exclude<PageIdWoofzPt1Bg, PageIdWoofzPt1Bg.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzPt1Bg.DOG_SEX_PT1_BG]: {
    id: PageIdWoofzPt1Bg.DOG_SEX_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.DOG_AGE_PT1_BG]: {
    id: PageIdWoofzPt1Bg.DOG_AGE_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.SHELTER_PT1_BG]: {
    id: PageIdWoofzPt1Bg.SHELTER_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.DOG_BREED_PT1_BG]: {
    id: PageIdWoofzPt1Bg.DOG_BREED_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.URGE_PT1_BG]: {
    id: PageIdWoofzPt1Bg.URGE_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_MENU,
  },
  [PageIdWoofzPt1Bg.STARTED_PT1_BG]: {
    id: PageIdWoofzPt1Bg.STARTED_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.PLACE_PT1_BG]: {
    id: PageIdWoofzPt1Bg.PLACE_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.GOALS_PT1_BG]: {
    id: PageIdWoofzPt1Bg.GOALS_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.ACCIDENTS_PT1_BG]: {
    id: PageIdWoofzPt1Bg.ACCIDENTS_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.CONCERNS_PT1_BG]: {
    id: PageIdWoofzPt1Bg.CONCERNS_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.URGE_2_PT1_BG]: {
    id: PageIdWoofzPt1Bg.URGE_2_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_MENU,
  },
  [PageIdWoofzPt1Bg.LIVING_SITUATION_PT1_BG]: {
    id: PageIdWoofzPt1Bg.LIVING_SITUATION_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.POTTY_BREAKS_PT1_BG]: {
    id: PageIdWoofzPt1Bg.POTTY_BREAKS_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.CRATE_TRAINING_PT1_BG]: {
    id: PageIdWoofzPt1Bg.CRATE_TRAINING_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.COMMANDS_PT1_BG]: {
    id: PageIdWoofzPt1Bg.COMMANDS_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.TRAINING_TIME_PT1_BG]: {
    id: PageIdWoofzPt1Bg.TRAINING_TIME_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageIdWoofzPt1Bg.PREPARE_FLOW_PT1_BG]: {
    id: PageIdWoofzPt1Bg.PREPARE_FLOW_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdWoofzPt1Bg.COMMITMENT_SCREEN_PT1_BG]: {
    id: PageIdWoofzPt1Bg.COMMITMENT_SCREEN_PT1_BG,
  },
  [PageIdWoofzPt1Bg.EMAIL_PT1_BG]: {
    id: PageIdWoofzPt1Bg.EMAIL_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdWoofzPt1Bg.NEWSLETTER_URGE_PT1_BG]: {
    id: PageIdWoofzPt1Bg.NEWSLETTER_URGE_PT1_BG,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdWoofzPt1Bg.SUBSCRIPTIONS_PT1_BG]: {
    id: PageIdWoofzPt1Bg.SUBSCRIPTIONS_PT1_BG,
  },
  [PageIdWoofzPt1Bg.CANCEL_OFFER_PT1_BG]: {
    id: PageIdWoofzPt1Bg.CANCEL_OFFER_PT1_BG,
  },
  [PageIdWoofzPt1Bg.CHAT_UPSELL_PT1_BG]: {
    id: PageIdWoofzPt1Bg.CHAT_UPSELL_PT1_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPt1Bg.UPSELL_PT1_BG]: {
    id: PageIdWoofzPt1Bg.UPSELL_PT1_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPt1Bg.UPSELL_FEEDING_GUIDE_PT1_BG]: {
    id: PageIdWoofzPt1Bg.UPSELL_FEEDING_GUIDE_PT1_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPt1Bg.UPSELL_EMOTIONAL_SUPPORT_PT1_BG]: {
    id: PageIdWoofzPt1Bg.UPSELL_EMOTIONAL_SUPPORT_PT1_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPt1Bg.DOWNLOAD_PT1_BG]: {
    id: PageIdWoofzPt1Bg.DOWNLOAD_PT1_BG,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
